import React from 'react';
import { LABEL_INPUT_FONT_SIZE } from '../../ConstsAndUtils/utils';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { Grid } from '@material-ui/core';

const PlaceHolderComponent = props => {
  return (
    <Grid
      container
      item
      xs={12}
      spacing={4}
      style={{
        marginTop: 5,
        marginBottom: 5,
      }}>
      <Grid item xs={12}>
        <h4>PLACEHOLDER TITLE</h4>
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          //inputProps={{style: { fontSize: 14 }}}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Placeholder"
          value={''}
          onChange={e => {}}
          helperText={''}
          onBlur={() => {}}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Placeholder"
          value={''}
          onChange={e => {}}
          helperText={''}
          onBlur={() => {}}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="PLACEHOLDER"
          value={''}
          onChange={e => {}}
          helperText={''}
          onBlur={() => {}}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          //inputProps={{style: { fontSize: 14 }}}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Placeholder"
          value={''}
          onChange={e => {}}
          helperText={''}
          onBlur={() => {}}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Placeholder"
          value={''}
          onChange={e => {}}
          helperText={''}
          onBlur={() => {}}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="PLACEHOLDER"
          value={''}
          onChange={e => {}}
          helperText={''}
          onBlur={() => {}}
        />
      </Grid>
    </Grid>
  );
};

export default PlaceHolderComponent;
